import { Grid } from '@material-ui/core';
import Loader from 'app/components/Loader';
import React, { FunctionComponent } from 'react';
import { useQuery } from 'react-query';
import { showReport } from 'reports/Requests';
import HashtagCompare from '../HashtagCompare';
import HashtagSingle from '../HashtagSingle';
import InfluencerSingle from '../InfluencerSingle';
import PostsPreview from '../PostsPreview';

interface Props {
  id: string;
  moduleName: string;
}

const TemplateVersionToDownload: FunctionComponent<Props> = ({
  id,
  moduleName,
}) => {
  const { isLoading, data } = useQuery(
    ['showReport', { report_id: +id }],
    showReport,
    {
      onError: () => {
        return true;
      },
    }
  );
  const isCompare = data?.type !== 'REPORT';
  const infId = data?.items?.[0]?.id;

  const filterSlugs = (slugs: any) => {
    return slugs?.filter((i: any) => i?.is_active);
  };
  const modules: any = {
    hashtags: isCompare ? (
      <HashtagCompare
        isTemplate
        items={data?.charts}
        reportHashtag={data?.items}
        isForDownload
        reportData={data}
      />
    ) : (
      <HashtagSingle
        isTemplate
        items={data?.charts}
        reportHashtag={data?.items?.[0]}
        reportData={data}
      />
    ),
    influencers: (
      <InfluencerSingle
        isTemplate
        isReport
        items={filterSlugs(data?.charts)}
        isInfluencer
        toDownloadId={infId}
        reportData={data}
      />
    ),
    tweets: (
      <InfluencerSingle
        isReport
        isTemplate
        items={filterSlugs(data?.charts)}
        toDownloadId={infId}
        reportData={data}
      />
    ),
    entities: (
      <InfluencerSingle
        isTemplate
        isReport
        isEntity
        items={filterSlugs(data?.charts)}
        toDownloadId={infId}
        reportData={data}
      />
    ),
    posts: (
      <PostsPreview
        items={filterSlugs(data?.charts)}
        reportData={data}
        sub_module={data?.sub_module_name}
      ></PostsPreview>
    ),
  };
  const comp = modules[moduleName];

  if (isLoading) return <Loader />;
  return (
    <Grid container spacing={4} style={{ padding: 30 }}>
      {comp}
    </Grid>
  );
};

export default TemplateVersionToDownload;
